import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneInput.styl';

/**
 * @event onEnter {value:string} при нажатии на enter
 * @event onInput {value:string}
 * @event onFocus {}
 * @event onBlur {}
 */
Vue.component('BXmakerAuthuserphoneInput',
    {
        props: {
            title: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ()=>{
                    return Math.random().toString(16).substring(2, 8) + '_' + (new Date).getTime();
                }
            },
            type: {
                type: String,
                default: 'text'
            },
            validationMessage: {
                type: [String, Boolean],
                default: false
            },
            maxLength: {
                type: [Number, Boolean],
                default: false
            },
            as:{
                type: String,
                default: ''
            }
        },
        data: function () {
            return {
                inFocus: false,
                isHover: false,
            };
        },
        computed: {
            classes() {
                let ar = [];
                if (this.inFocus || this.value.length > 0) {
                    ar.push('bxmaker-authuserphone-input--focus');
                }
                if (this.isHover) {
                    ar.push('bxmaker-authuserphone-input--hover');
                }

                if (this.validationMessage) {
                    ar.push('bxmaker-authuserphone-input--invalid');
                }

                return ar;
            }

        },
        methods: {
            onFocus() {
                this.inFocus = true;
                this.$emit('onFocus');
            },
            onBlur() {
                this.inFocus = false;
                this.$emit('onBlur');
            },
            onInput(e) {
                this.$emit('onInput', e.target.value)
            },
            onKeydown(e) {
                switch (e.keyCode) {
                    case 13://enter
                    {
                        this.$emit('onEnter', e.target.value)
                        return;
                    }
                }
            },
            onMouseenter(){
                this.isHover = true;
            },
            onMouseleave(){
                this.isHover = false;
            },
            // активация фокуса на поле
            focus(){
                this.$refs.input.focus();
            }
        },
        template: `
            <div class="bxmaker-authuserphone-input " :class="classes" >
                <div class="bxmaker-authuserphone-input__field">
                    <input :type="type" :name="name" 
                    @focus="onFocus" 
                    @blur="onBlur"
                     @input="onInput" 
                     @mouseenter="onMouseenter" 
                     @mouseleave="onMouseleave" 
                     @keydown="onKeydown" 
                     :value="value"
                      autocomplete="off"
                      :maxlength="maxLength"
                      ref="input"
                      >
                    <span class="bxmaker-authuserphone-input__title">{{title}}</span>  
                </div>
                <div class="bxmaker-authuserphone-input__validation" v-if="validationMessage">{{validationMessage}}</div>                
            </div>
        `,
    });